'use strict';

import React from 'react';

require('styles/search/Input.css');

class InputComponent extends React.Component {
  constructor(props) {
      super(props);
      this.state = {
          searchStock: true,
          isStoreDisabled: false
      };

      this.handleSearchChange = this.handleSearchChange.bind(this)
      this.handleStoreChange = this.handleStoreChange.bind(this)
      this.handleCountryChange = this.handleCountryChange.bind(this)
      this.handleStockToggleChange = this.handleStockToggleChange.bind(this)
      this.handleSortChange = this.handleSortChange.bind(this)
      this.handleCategoryChange = this.handleCategoryChange.bind(this)
      this.handleSubmit = this.handleSubmit.bind(this)
      this.triggerSearch = this.triggerSearch.bind(this)

  }

  triggerSearch() {
    if (!this.state.search_term) {
      return
    }
    this.props.searchHandler(this.state.search_term, this.state.searchStore, this.state.searchCountry, this.state.searchStock, this.state.searchCategory, this.state.searchSort);
  }

  handleSearchChange(event) {
    this.setState({'search_term': event.target.value});
    if (this.timer) {
      clearTimeout(this.timer)
    }
    this.timer = setTimeout(this.triggerSearch, 1000);
  }

  handleStoreChange(event) {
    var searchStore = event.target.value
    if (event.target.value == "Store" || event.target.value == "All") {
      searchStore = '';
    }

    this.setState({'searchStore': searchStore}, this.triggerSearch);
  }

  handleCountryChange(event) {
    var isStoreDisabled = false;
    var searchCountry = event.target.value;
    if (event.target.value != "Country" && event.target.value != "All") {
      isStoreDisabled = true;
    } else {
      searchCountry = ""
    }
    this.setState({'searchCountry': searchCountry, 'isStoreDisabled': isStoreDisabled}, this.triggerSearch);
  }

  handleStockToggleChange(event) {
    this.setState({'searchStock': !this.state.searchStock}, this.triggerSearch);
  }

  handleSortChange(event) {
    this.setState({'searchSort': event.target.value}, this.triggerSearch);
  }

  handleCategoryChange(event) {
    var cat = event.target.value;
    if (cat == "Category" || cat == "All") {
      cat = ""
    }

    this.setState({'searchCategory': cat}, this.triggerSearch);
  }

  handleSubmit(event) {
    this.triggerSearch()
    // this.props.searchHandler(this.state.search_term, this.state.searchStore, this.state.searchCountry, this.state.searchStock, this.state.searchSort);
    event.preventDefault();
  }

  render() {
    var formGroupStyle = {
      marginLeft:0,
      marginRight:0,
      marginBottom:"1em"
    }
    var textStyle = {
      color: "white"
    }

    return (
      <form className="form" role="search" onSubmit={this.handleSubmit} >
        <div className="form-group form-group-lg row-fluid" style={formGroupStyle}>
          <div className="input-group input-group-lg">
            <input type="text" className="form-control" onChange={this.handleSearchChange} placeholder="Search for multicopter and RC products"></input>
            <span className="input-group-btn">
              <button className="btn btn-default" type="button">Go!</button>
            </span>
          </div>
        </div>
        <div className="form-group-sm row-fluid" style={textStyle}>
          <div className="col-xs-12 col-lg-1">
            <label>Filter By:</label>
          </div>
          <div className="col-xs-6 col-lg-2">
            <select className="form-control" onChange={this.handleCountryChange} >
              <option>Country</option>
              <option>USA</option>
              <option>China</option>
              <option>Canada</option>
              <option>All</option>
            </select>
          </div>
          <div className="col-xs-6 col-lg-2">
            <select className="form-control" onChange={this.handleStoreChange} disabled={this.state.isStoreDisabled}>
              <option>Store</option>
              <option value="getfpv">GetFPV</option>
              <option value="hobby_king">Hobbyking</option>
              <option value="rotorgeeks">Rotorgeeks</option>
              <option value="foxtechfpv">Foxtech</option>
              <option value="multirotorsuperstore">Multirotor Superstore</option>
              <option value="readymaderc">ReadyMadeRC</option>
              <option value="banggood">Banggood</option>
              <option>All</option>
            </select>
          </div>
          <div className="col-xs-12 col-lg-2">
            <select className="form-control" onChange={this.handleCategoryChange}>
              <option>Category</option>
              <option value="Frames">Frames</option>
              <option value="Propellers">Propellers</option>
              <option value="Accessories">Accessories</option>
              <option value="Electronics">Electronics</option>
              <option value="Motors">Motors</option>
              <option value="Batteries">Batteries</option>
              <option value="Radio">Radio</option>
              <option value="Video">Video</option>
              <option value="Planes">Planes</option>
              <option value="Boats">Boats</option>
              <option value="Cars">Cars</option>
              <option value="Helis">Helis</option>
              <option value="Multicopters">Multicopters</option>
              <option>All</option>
            </select>
          </div>

          <div className="col-xs-12 col-lg-2">
            <label>
              <input type="checkbox" onClick={this.handleStockToggleChange} checked={this.state.searchStock} defaultChecked/>
              <span>Show out of stock</span>
            </label>
          </div>
          <div className="col-xs-3 col-lg-1">
            <label>Sort By:</label>
          </div>
          <div className="col-xs-9 col-lg-2">
            <select className="form-control" onChange={this.handleSortChange}>
              <option value="bestMatch">Best Match</option>
              <option value="lowestPrice">Lowest Price</option>
            </select>
          </div>

        </div>
      </form>
    )
  }
}

InputComponent.displayName = 'SearchInputComponent';

// Uncomment properties you need
// InputComponent.propTypes = {};
// InputComponent.defaultProps = {};

export default InputComponent;



/** WEBPACK FOOTER **
 ** ./src/components/search/InputComponent.js
 **/